import { Options, Vue } from "vue-class-component";

@Options({
    name: "duplicate-icon",
})
export default class DuplicateIcon extends Vue {
}
